import { defineComponent, ref, openBlock, createBlock, unref, withCtx, createTextVNode, toDisplayString, renderSlot, createCommentVNode } from "vue";
import { r as register, f as t34, a as t } from "./_l10n.mjs";
import { N as NcButton } from "./NcButton.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper.mjs";
import { N as NcLoadingIcon } from "./NcLoadingIcon.mjs";
register(t34);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcDialogButton",
  props: {
    callback: { type: Function, default: () => {
    } },
    disabled: { type: Boolean, default: false },
    icon: { default: void 0 },
    label: {},
    type: { default: "button" },
    variant: { default: "tertiary" }
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const isLoading = ref(false);
    async function handleClick(e) {
      if (isLoading.value) {
        return;
      }
      isLoading.value = true;
      try {
        const fallback = props.type === "reset" ? false : void 0;
        const result = await props.callback?.() ?? fallback;
        if (result !== false) {
          emit("click", e, result);
        }
      } finally {
        isLoading.value = false;
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NcButton), {
        "aria-label": __props.label,
        disabled: __props.disabled,
        type: __props.type,
        variant: __props.variant,
        onClick: handleClick
      }, {
        icon: withCtx(() => [
          renderSlot(_ctx.$slots, "icon", {}, () => [
            isLoading.value ? (openBlock(), createBlock(unref(NcLoadingIcon), {
              key: 0,
              name: unref(t)("Loading …")
              /* TRANSLATORS: The button is in a loading state*/
            }, null, 8, ["name"])) : __props.icon !== void 0 ? (openBlock(), createBlock(unref(NcIconSvgWrapper), {
              key: 1,
              svg: __props.icon
            }, null, 8, ["svg"])) : createCommentVNode("", true)
          ])
        ]),
        default: withCtx(() => [
          createTextVNode(toDisplayString(__props.label) + " ", 1)
        ]),
        _: 3
      }, 8, ["aria-label", "disabled", "type", "variant"]);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=NcDialogButton.vue_vue_type_script_setup_true_lang.mjs.map
